var map = {
	"./horizontal/en/color-black.svg": 569,
	"./horizontal/en/color-white.svg": 570,
	"./horizontal/en/mono-black.svg": 571,
	"./horizontal/uk/color-black.svg": 572,
	"./horizontal/uk/color-white.svg": 573,
	"./horizontal/uk/mono-black.svg": 574,
	"./icon/default/lun_icon.svg": 575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 568;